<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_iv"></a>List of Plates</h2>
<p class="lista">A typical British infantryman of the era in West Indies tropical service uniform. (Anne S K Brown Collection)</p>
<p class="lista">Lieutenant General Sir Charles Grey. Defeated as much by his own superiors and failing health as by the French, he deserves to be remembered as one of Britain’s best generals of the era. (National Portrait Gallery)</p>
<p class="lista">Vice Admiral Sir John Jervis. A fist of iron in a velvet glove. The naval commander and Grey’s best friend. (National Portrait Gallery)</p>
<p class="lista">Fort Royal, called République-ville in 1794. (Anne SK Brown Collection)</p>
<p class="lista">His family motto was ‘To live and die valiantly’; Donatien-Marie-Joseph de Vimeur, vicomte de Rochambeau certainly lived up to his creed commanding the French defence of Martinique in February and March 1794. (Public Domain)</p>
<p class="lista">Saint Pierre in 1794 as depicted satirically by Cooper Wylliams. Note the guillotine, and heads on spikes. (Anne S K Brown Collection)</p>
<p class="lista">A view across the bay towards Fort Louis on the right (called Fort de la Convention in 1794) with Grey’s light infantrymen in the foreground. (Anne SK Brown Collection)</p>
<p class="lista">The Royal Navy in action against Forts Bourbon and Louis (République and Convention). (Anne SK Brown Collection)</p>
<p class="lista">The valiant Captain Robert Faulknor leads HMS <em class="italic">Zebra</em> to glory at Fort de la République. His death the following year robbed the Royal Navy of a fine officer. (Anne SK Brown Collection)</p>
<p class="lista">The storming of Fort Royal on 24 March 1794. The uniform details are probably incorrect. (Anne SK Brown Collection)</p>
<p class="lista">The town of Basse-Terre in Guadeloupe in 1794. (Anne SK Brown Collection)</p>
<p class="lista">The beginning of the end. The capitulation of the defenders of Fort Fleur d’Epée on 7 June 1794. Much worse was to follow at Berville and Fort Matilda. (Public Domain)</p>
<p class="lista">Lieutenant General Robert Prescott. Undeniably valiant, but one of the most difficult subordinates to ever serve a field commander. (National Portrait Gallery)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// list_of_plates.vue?58cd172a